// extracted by mini-css-extract-plugin
export default {"cardMobile":"MobileProjectCard_cardMobile__borKr","image":"MobileProjectCard_image__AfXPZ"};